import { render, staticRenderFns } from "./OpenSourceIcon.vue?vue&type=template&id=09e28535&"
import script from "./OpenSourceIcon.vue?vue&type=script&lang=js&"
export * from "./OpenSourceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports